import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import onClickOutside from 'react-onclickoutside';
import classNames from 'classnames';
import isEqual from 'lodash/fp/isEqual';
import logPropError from '../../utils/logPropError';
import logDeprecatedWarnings from '../../utils/logDeprecatedWarnings';
import isNil from 'lodash/fp/isNil';
import { BaseDropdownMenu } from './BaseDropdownMenu';
var errorProps = [{
  prop: 'toggleButtonLabel',
  replacement: 'selectedOptionText'
}];
var warningProps = [{
  prop: 'autoDropDirection'
}];
var DEFAULT_FOCUSED_ITEM_INDEX = -1;
export var Select = /*#__PURE__*/function (_Component) {
  _inherits(Select, _Component);
  var _super = _createSuper(Select);
  function Select(props) {
    var _this;
    _classCallCheck(this, Select);
    _this = _super.call(this, props);
    _this.state = {
      isOpen: false,
      selectedItem: null,
      isFilterActive: false,
      filterValue: '',
      filteredOptions: props.options,
      itemDOMValues: [],
      focusedItemIndex: DEFAULT_FOCUSED_ITEM_INDEX,
      keyboardUsed: false,
      requestItemDOMValues: false
    };
    _this.onToggle = _this.onToggle.bind(_assertThisInitialized(_this));
    _this.handleClickOutside = _this.handleClickOutside.bind(_assertThisInitialized(_this));
    _this.updateSelectedItem = _this.updateSelectedItem.bind(_assertThisInitialized(_this));
    _this.handleFilterChange = _this.handleFilterChange.bind(_assertThisInitialized(_this));
    _this.onOptionChange = _this.onOptionChange.bind(_assertThisInitialized(_this));
    _this.updateDOMValues = _this.updateDOMValues.bind(_assertThisInitialized(_this));
    _this.closeMenu = _this.closeMenu.bind(_assertThisInitialized(_this));
    _this.onOpenMenu = _this.onOpenMenu.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Select, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.updateSelectedItem(this.props.options, this.props.value);
    }

    // eslint-disable-next-line camelcase
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.updateSelectedItem(nextProps.options, nextProps.value);
      if (!isEqual(nextProps.options, this.props.options)) {
        this.setState({
          filteredOptions: nextProps.options,
          requestItemDOMValues: true
        });
      }
    }
  }, {
    key: "updateSelectedItem",
    value: function updateSelectedItem(options, value) {
      if (value) {
        this.setState(function () {
          return {
            selectedItem: options.find(function (item) {
              return item.id === value[0];
            })
          };
        });
      } else if (options) {
        this.setState(function () {
          return {
            selectedItem: options.find(function (item) {
              return item.selected;
            })
          };
        });
      }
    }
  }, {
    key: "updateDOMValues",
    value: function updateDOMValues() {
      var itemDOMValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.setState(function () {
        return {
          itemDOMValues: itemDOMValues,
          requestItemDOMValues: false
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        className = _this$props.className,
        hasError = _this$props.hasError,
        dropup = _this$props.dropup;
      var classes = classNames('select', dropup && 'dropup', 'dropdown', hasError && 'has-error', this.state.isOpen && 'open', className && className);
      return /*#__PURE__*/React.createElement("div", {
        className: classes,
        ref: function ref(node) {
          return _this2.refSelect = node;
        }
      }, this.renderToggle(), this.renderDropdownMenu());
    }
  }, {
    key: "renderUnselectedItemIcons",
    value: function renderUnselectedItemIcons(options, selectedItem) {
      var optionSpans = options.filter(function (option) {
        return !option.header;
      }).map(function (option) {
        return /*#__PURE__*/React.createElement("span", {
          key: option.id,
          className: "margin-right-5 ".concat(selectedItem && selectedItem.id === option.id ? '' : 'inactiveIcon')
        }, option.icon);
      });
      return /*#__PURE__*/React.createElement("span", null, optionSpans);
    }
  }, {
    key: "getSeletedItemLabel",
    value: function getSeletedItemLabel(selectedItem, placeholder) {
      if (this.props.showUnselectedItemIcons) {
        return this.renderUnselectedItemIcons(this.props.options, selectedItem);
      }
      if (!selectedItem) {
        // render a placeholder or if there is none render a non-breaking space "&nbsp;"
        return placeholder ? /*#__PURE__*/React.createElement("span", {
          className: "placeholder"
        }, placeholder) : "\xA0";
      }
      return /*#__PURE__*/React.createElement("span", null, selectedItem.icon && /*#__PURE__*/React.createElement("span", {
        className: "margin-right-5"
      }, selectedItem.icon), !this.props.showSelectedItemIcon && selectedItem.label);
    }
  }, {
    key: "renderClearButton",
    value: function renderClearButton() {
      var _this3 = this;
      var _this$props2 = this.props,
        onChange = _this$props2.onChange,
        useClear = _this$props2.useClear;
      var clearSelectedItem = function clearSelectedItem() {
        _this3.setState(function () {
          return {
            selectedItem: undefined,
            isFilterActive: false,
            filterValue: ''
          };
        });
        onChange();
      };
      var clearButtonClassNames = classNames('clearButton', (!useClear || isNil(this.state.selectedItem)) && 'hide pointer-events-none');
      return /*#__PURE__*/React.createElement("span", {
        className: clearButtonClassNames,
        onClick: clearSelectedItem
      }, /*#__PURE__*/React.createElement("span", {
        className: "clearButtonIcon rioglyph rioglyph-remove-sign"
      }));
    }
  }, {
    key: "renderToggle",
    value: function renderToggle() {
      var _this4 = this;
      var _this$props3 = this.props,
        bsSize = _this$props3.bsSize,
        btnClassName = _this$props3.btnClassName,
        tabIndex = _this$props3.tabIndex,
        useFilter = _this$props3.useFilter,
        placeholder = _this$props3.placeholder,
        disabled = _this$props3.disabled,
        name = _this$props3.name,
        label = _this$props3.label,
        _this$props3$id = _this$props3.id,
        id = _this$props3$id === void 0 ? name : _this$props3$id,
        selectedOptionText = _this$props3.selectedOptionText;
      logPropError(errorProps, this.props, 'Select');
      logDeprecatedWarnings(warningProps, this.props, 'Select');
      var _this$state = this.state,
        isOpen = _this$state.isOpen,
        selectedItem = _this$state.selectedItem;
      var classnames = classNames('dropdown-toggle', 'form-control', 'text-left', btnClassName && btnClassName, bsSize === 'large' && 'input-lg',
      // TODO: deprecte since it's not consistent
      bsSize === 'small' && 'input-sm',
      // TODO: deprecte since it's not consistent
      bsSize === 'sm' && 'input-sm', bsSize === 'lg' && 'input-lg', disabled && 'disabled');
      var selectedOption = /*#__PURE__*/React.createElement("span", {
        className: "selected-option-text"
      }, label && /*#__PURE__*/React.createElement("span", {
        className: "selected-option-text-label"
      }, label, ":"), /*#__PURE__*/React.createElement("span", null, this.getSeletedItemLabel(selectedItem, placeholder)));
      return /*#__PURE__*/React.createElement("button", {
        type: "button",
        id: id,
        name: name,
        className: classnames,
        "data-toggle": "dropdown",
        tabIndex: tabIndex,
        "aria-haspopup": "true",
        "aria-expanded": isOpen,
        onClick: this.onToggle,
        ref: function ref(node) {
          return _this4.refToggle = node;
        }
      }, useFilter && isOpen && this.renderFilterInput(), selectedOptionText ? selectedOptionText : selectedOption, this.renderClearButton(), /*#__PURE__*/React.createElement("span", {
        className: "caret"
      }));
    }
  }, {
    key: "renderDropdownMenu",
    value: function renderDropdownMenu() {
      var _this5 = this;
      // console.log('keyboardUsed=' + this.state.keyboardUsed)

      var _this$props4 = this.props,
        pullRight = _this$props4.pullRight,
        noItemMessage = _this$props4.noItemMessage,
        dropdownClassName = _this$props4.dropdownClassName;

      // When an option was already selected, highlight this option by setting the focusedItemIndex accordingly.
      // In case there was nothing preselected, set the focusedItemIndex to the first item if keayboard was used.
      var focusedItemIndex = this.state.focusedItemIndex;
      if (this.state.selectedItem) {
        focusedItemIndex = this.props.options.findIndex(function (option) {
          return option.id === _this5.state.selectedItem.id;
        });
      } else if (this.state.keyboardUsed) {
        focusedItemIndex = 0;
      }

      // console.log('focusedItemIndex=' + focusedItemIndex);

      return /*#__PURE__*/React.createElement(BaseDropdownMenu, {
        isOpen: this.state.isOpen,
        options: this.state.filteredOptions,
        focusedItemIndex: focusedItemIndex,
        keyboardUsed: this.state.keyboardUsed,
        updateDOMValues: this.updateDOMValues,
        onOpen: this.onOpenMenu,
        onSelect: this.onOptionChange,
        onClose: this.closeMenu,
        noItemMessage: noItemMessage,
        pullRight: pullRight,
        dropdownClassName: dropdownClassName,
        requestItemDOMValues: this.state.requestItemDOMValues
      });
    }
  }, {
    key: "renderFilterInput",
    value: function renderFilterInput() {
      var inputClasses = classNames('select-filter-input', (this.state.isFilterActive || this.state.filterValue) && 'select-filter-input-active');
      return /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: inputClasses,
        autoFocus: true,
        onChange: this.handleFilterChange,
        value: this.state.filterValue
      });
    }
  }, {
    key: "filterOptions",
    value: function filterOptions() {
      var itemDOMValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var filterValue = arguments.length > 1 ? arguments[1] : undefined;
      var options = arguments.length > 2 ? arguments[2] : undefined;
      var filteredDOMValues = itemDOMValues.filter(function (item) {
        return item.text.toLowerCase().includes(filterValue.toLowerCase());
      });

      // Filter the options according to the filtered DOM values and map the IDs since the filter cannot be done
      // on the options itself as they might contain arbitrary components
      return options.filter(function (option) {
        return filteredDOMValues.find(function (value) {
          return value.id === option.id;
        });
      });
    }
  }, {
    key: "handleFilterChange",
    value: function handleFilterChange(event) {
      event.preventDefault();
      var filterValue = event.currentTarget.value;
      var filteredOptions = this.filterOptions(this.state.itemDOMValues, filterValue, this.props.options);

      // highlight the first item of the search result if at least one item was found
      var newFocusedItemIndex = filteredOptions.length > 0 ? 0 : DEFAULT_FOCUSED_ITEM_INDEX;
      this.setState(function () {
        return {
          isFilterActive: true,
          filterValue: filterValue,
          filteredOptions: filteredOptions,
          keyboardUsed: true,
          focusedItemIndex: newFocusedItemIndex
        };
      });
    }
  }, {
    key: "onOptionChange",
    value: function onOptionChange(event, selectedItem) {
      var _this6 = this;
      this.setState(function () {
        return {
          selectedItem: selectedItem,
          isFilterActive: false,
          filterValue: '',
          filteredOptions: _this6.props.options
        };
      });

      // Needed? - was once added by a Service Team (guess it was Chat)
      if (event.target) {
        event.target.value = this.state.selectedItem;
      }
      this.props.onChange(selectedItem);
      this.closeMenu();
    }
  }, {
    key: "isAutoDropActive",
    value: function isAutoDropActive() {
      return !(!this.props.autoDropDirection || this.props.dropup || this.props.pullRight);
    }
  }, {
    key: "onToggle",
    value: function onToggle(event) {
      // Dont toggle when component is disabled or
      // when filter is active, means entering some filter value
      // in order to avoid closing menu on space but allow to use it for filtering
      if (this.props.disabled || this.state.isFilterActive) {
        return;
      }

      // using the enter key on the toggle button will trigger a synthetic click event as all buttons are of
      // type submit by default in HTML. In order to differentiate between real click and a synthetic event
      // caused by they keyboard, use the event details. A synthetic event is always 0.
      var keyboardUsed = event.detail === 0;
      this.setState({
        isOpen: !this.state.isOpen,
        keyboardUsed: keyboardUsed
      });
    }
  }, {
    key: "onOpenMenu",
    value: function onOpenMenu(dropup) {
      var node = ReactDOM.findDOMNode(this);
      if (dropup) {
        node.classList.add('dropup');
      } else {
        node.classList.remove('dropup');
      }
    }
  }, {
    key: "closeMenu",
    value: function closeMenu() {
      var _this7 = this;
      if (this.state.isOpen) {
        this.setState(function () {
          return {
            isOpen: false,
            isFilterActive: false,
            filterValue: '',
            filteredOptions: _this7.props.options,
            keyboardUsed: false,
            focusedItemIndex: DEFAULT_FOCUSED_ITEM_INDEX
          };
        });
        this.refToggle.focus();
      }
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside() {
      this.closeMenu();
    }
  }]);
  return Select;
}(Component);
Select.defaultProps = {
  onChange: function onChange() {},
  options: [],
  disabled: false,
  pullRight: false,
  dropup: false,
  hasError: false,
  useFilter: false,
  tabIndex: 0,
  showSelectedItemIcon: false,
  showUnselectedItemIcons: false,
  useClear: false
};
Select.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  options: PropTypes.arrayOf(PropTypes.shape({
    // Identify an option
    id: PropTypes.string.isRequired,
    // A label to show in body
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    // An icon to show in body
    icon: PropTypes.node,
    selected: PropTypes.bool,
    disabled: PropTypes.bool,
    header: PropTypes.bool
  })),
  onChange: PropTypes.func,
  // Text that will be used instead of the selected item text
  selectedOptionText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  // Text to display when no menu item is selected
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  dropup: PropTypes.bool,
  pullRight: PropTypes.bool,
  autoDropDirection: PropTypes.bool,
  // the current "value" - alternatively use options.selected instead
  value: PropTypes.array,
  bsSize: PropTypes.oneOf(['sm', 'lg', 'small', 'large']),
  disabled: PropTypes.bool,
  className: PropTypes.string,
  btnClassName: PropTypes.string,
  dropdownClassName: PropTypes.string,
  tabIndex: PropTypes.number,
  hasError: PropTypes.bool,
  useFilter: PropTypes.bool,
  // Text to display when no menu item is selected
  noItemMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  // shows icons as selected values
  showSelectedItemIcon: PropTypes.bool,
  // shows icons always with active or inactive state
  showUnselectedItemIcons: PropTypes.bool,
  // Adds a clear button
  useClear: PropTypes.bool
};
export default onClickOutside(Select);